// extracted by css-extract-rspack-plugin
export default {"row":"gfMRU","wrap":"noJhG","nowrap":"SVz4d"};